import React from 'react';
import { DynamicCatalogBuilder } from '../../../../builderPackage/components/dynamicCatalogBuilder/dynamicCatalogBuilder';
import { Chip } from '@mui/material';
var CQAHistoryTabReceivedEdit = function () {
    var columns = [{
            field: 'SrNo',
            headerName: 'Sr. no.',
            headerAlign: 'center',
            minWidth: 100,
            align: 'center'
        }, {
            type: 'string',
            field: 'DateAndTime',
            headerName: 'Date & time',
            minWidth: 150,
            flex: 1
        }, {
            field: 'User',
            headerName: 'User',
            minWidth: 150,
            flex: 1
        }, {
            field: 'Department',
            headerName: 'Department',
            minWidth: 150,
            flex: 1
        }, {
            field: 'Ageingdays',
            headerName: 'Ageing days',
            minWidth: 100,
            flex: 1
        }, {
            field: 'Remark',
            headerName: 'Remark',
            minWidth: 150,
            flex: 1
        }, {
            field: 'status',
            headerName: 'Status',
            flex: 1,
            minWidth: 180,
            renderCell: function (params) { /*#__PURE__*/ return React.createElement(Chip, {
                label: 'Submitted to ASM',
                size: "small",
                color: "info",
                shape: "rounded"
            }); }
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(DynamicCatalogBuilder, {
        columns: columns,
        rows: [{
                id: 1,
                SrNo: '1',
                DateAndTime: '21 Aug, 2002 • 11:09 AM',
                User: 'BM Rushikesh',
                Department: 'Dealer',
                Ageingdays: '0',
                Remark: 'A little about the company and the team that you’ll be working with.',
                status: 'Submitted to ASM'
            }, {
                id: 2,
                SrNo: '2',
                DateAndTime: '21 Aug, 2002 • 11:09 AM',
                User: 'BM Rushikesh',
                Department: 'Dealer',
                Ageingdays: '0',
                Remark: 'A little about the company and the team that you’ll be working with.',
                status: 'Submitted to ASM'
            }],
        dataGridProps: {
            hideFooter: true,
            sx: {
                borderRadius: 0,
                borderLeft: 'none',
                borderRight: 'none',
                borderBottom: 'none'
            }
        }
    }));
};
export default CQAHistoryTabReceivedEdit;
